<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :yaxis="[{min: 0}]"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :colors="[ '#b3b3b3', '#008FFB', '#00E396', '#FEB019', '#FF4560']"
      :markers="{ colors: [ '#b3b3b3', '#008FFB', '#00E396', '#FEB019', '#FF4560']}"
      :fill="{ opacity: [0.5, 0.5, 0.5, 0.5, 0.5]}"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ aggregation ? $t(`variables.${aggregation}.long`) + ":" : '' }} {{ $t("card_title.hr_zone_analysis") }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ aggregation ? $t(`variables.${aggregation}.long`) + ":" : '' }} {{ $t("card_title.hr_zone_analysis") }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="players"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'HrZoneChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      return [
        { key: addAggregation('ZONE1DR'), type: 'bar', label: this.$t('hr_variables.regeneration') },
        { key: addAggregation('ZONE2DR'), type: 'bar', label: this.$t('hr_variables.extensive_aerobic_zone') },
        { key: addAggregation('ZONE3DR'), type: 'bar', label: this.$t('hr_variables.intensive_aerobic_zone') },
        { key: addAggregation('ZONE4DR'), type: 'bar', label: this.$t('hr_variables.anaerobic_threshold_zone') },
        { key: addAggregation('ZONE5DR'), type: 'bar', label: this.$t('hr_variables.vo2_max_zone') }
      ]
    },
    tableHeaders() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      const valuePrefix = this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.'

      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '25%'
        },
        {
          text: this.$t('hr_variables.regeneration'),
          value: valuePrefix + addAggregation('ZONE1DR'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('hr_variables.extensive_aerobic_zone'),
          value: valuePrefix + addAggregation('ZONE2DR'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('hr_variables.intensive_aerobic_zone'),
          value: valuePrefix + addAggregation('ZONE3DR'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('hr_variables.anaerobic_threshold_zone'),
          value: valuePrefix + addAggregation('ZONE4DR'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('hr_variables.vo2_max_zone'),
          value: valuePrefix + addAggregation('ZONE5DR'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
